// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yPiC","title":"styles_title__3-wVD"};